<template>
  <div class="filter-comp">
    <ElementForm
      v-for="(item, index) in newData"
      class="form"
      :key="index"
      :form="item"
      @onAttr="onAttr($event, item, index)"
    />
  </div>
</template>

<script>
import ElementForm from '../../../../components/FormComponents'
export default {
  name: 'filter-comp',
  components: {
    ElementForm
  },
  props: {
    data: [Array, Object]
  },
  data () {
    return {
      newData: this.data
    }
  },
  methods: {
    onAttr (target, item, index) {
      this.$emit('onFilterComp', target, item, index)
    }
  }
}
</script>

<style lang="scss" scoped>
.filter-comp {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom: 10px;

  .form{
    margin-right: 10px;

    /deep/ .item{
      margin-bottom: 4px;
    }
    /deep/ .item{
      padding-left: 0px !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/IMTable/components/filterComp/index.vue